import {
  ChangeDetectorRef,
  Component,
  OnInit,
  EventEmitter,
  Output,
} from "@angular/core";
import { DashboardData, News } from "src/app/shared/models/dashboard.model";
import { BroshService } from "src/app/shared/services/brosh.service";
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { Store } from "@ngrx/store";
import { dashboardData } from "src/app/shared/ngrx/ngrx-selectors";
import { REQUEST_DASHBOARD_REFRESH } from "src/app/shared/ngrx/ngrx-actions";
import { TranslateModule } from "@ngx-translate/core";
import { FormsModule } from "@angular/forms";
import { SpinnerComponent } from "src/app/shared/components/ui/spinner/spinner.component";
import { CommonModule } from "@angular/common";

@Component({
  selector: "edit-news",
  templateUrl: "./edit-news.component.html",
  styleUrls: ["./edit-news.component.scss"],
  imports: [TranslateModule, CommonModule, FormsModule, SpinnerComponent],
  standalone: true,
})
export class EditNewsComponent implements OnInit {
  @Output() onCancel = new EventEmitter();
  data: News[] = [];
  saving: boolean;

  constructor(
    private readonly store: Store,
    private broshService: BroshService,
    // the hosting dash-news is OnPush; async writes here must mark the path
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.data = JSON.parse(
      JSON.stringify(this.store.selectSignal(dashboardData)().news)
    );
  }

  public closePanel() {
    this.onCancel.emit();
  }

  save() {
    this.saving = true;
    this.broshService.updateDashboardNews(this.data).subscribe(
      () => {
        this.saving = false;
        this.store.dispatch(REQUEST_DASHBOARD_REFRESH());

        this.closePanel();
        this.cdr.markForCheck();
      },
      () => {
        this.saving = false;
        this.cdr.markForCheck();
      }
    );
  }

  add() {
    this.data.push(new News());
  }

  deleteItem(item: News) {
    this.data.splice(this.data.indexOf(item), 1);
  }

  drop(event: any) {
    moveItemInArray(this.data, event.previousIndex, event.currentIndex);
  }
}
